/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./owl-child.component";
var styles_OwlChild = [];
var RenderType_OwlChild = i0.ɵcrt({ encapsulation: 2, styles: styles_OwlChild, data: {} });
export { RenderType_OwlChild as RenderType_OwlChild };
export function View_OwlChild_0(_l) { return i0.ɵvid(0, [i0.ɵncd(null, 0)], null, null); }
export function View_OwlChild_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "owl-carousel-child", [], [[2, "owl-carousel", null]], null, null, View_OwlChild_0, RenderType_OwlChild)), i0.ɵdid(1, 4440064, null, 0, i1.OwlChild, [i0.ElementRef], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, function (_ck, _v) { var currVal_0 = i0.ɵnov(_v, 1).owlClass; _ck(_v, 0, 0, currVal_0); }); }
var OwlChildNgFactory = i0.ɵccf("owl-carousel-child", i1.OwlChild, View_OwlChild_Host_0, { options: "options" }, {}, ["*"]);
export { OwlChildNgFactory as OwlChildNgFactory };
